import classNames from 'classnames/bind';
import { TripType } from 'contexts/searchParams';
import { Dispatch, SetStateAction } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  className?: string;
  active: boolean;
  isDisabled: boolean;
  clickCodePrefix: string;
  tripType: TripType;
  title?: string;
  setTripType?: (tripType: TripType) => void;
  setIsMultiCityExpanded: Dispatch<SetStateAction<boolean>>;
}

const clickCodeMap = new Map([
  [TripType.RT, 'roundtrip'],
  [TripType.OW, 'oneway'],
  [TripType.MD, 'multiple'],
  [TripType.NULL, ''],
]);

export default function Tab({
  className,
  active,
  isDisabled,
  clickCodePrefix,
  tripType,
  title,
  setTripType,
  setIsMultiCityExpanded,
}: IProps) {
  const handleClick = () => {
    if (!setTripType) return;
    if (!active) {
      setTripType(tripType);
      if (tripType === TripType.MD) {
        setIsMultiCityExpanded(true);
      }
    }
  };

  return (
    <button
      className={cx(className, 'Tab')}
      role="tab"
      type="button"
      aria-selected={active}
      aria-disabled={isDisabled}
      data-event-nlog="click"
      data-event-area-code={`${clickCodePrefix}.${clickCodeMap.get(tripType)}`}
      onClick={handleClick}
    >
      <i className={cx('text')}>{title}</i>
    </button>
  );
}
